module.exports = __webpack_public_path__ + "fonts/Libre_Franklin-600-latin-ext11.d035c4a.woff2";